// extracted by mini-css-extract-plugin
var _1 = "JzFFC";
var _2 = "YT6QB";
var _3 = "I6exd";
var _4 = "Aq0d5 custom-attribute-color";
var _5 = "MPoOx";
export { _1 as "base", _2 as "count", _3 as "label", _4 as "option", _5 as "options" }
